<template>
    <center>
        <div class="card card-body agatrs-card-style-sm" v-if="!isPartnerAccount">
            <div class="row">
                <div class="col-md-12 black subscription_container">
                    <h2 class="text_center no-bottom-margin">Email Subscriptions</h2>
                    <hr>
                    <div class="form-group">
                      
                        <base-checkbox :disabled="isPartnerAccount" v-model="subscription.thirtyDay">30 Day Overdue</base-checkbox>

                        <base-checkbox :disabled="isPartnerAccount" v-model="subscription.sixtyDay">60 Day Overdue</base-checkbox>

                        <base-checkbox :disabled="isPartnerAccount" v-model="subscription.ninetyDay">90 Day Overdue</base-checkbox>
                    </div>
                </div>
                <div class="col-md-12">
                    <base-button :disabled="isPartnerAccount" @click="save"
                                 type="primary">
                        Save
                    </base-button>
                </div>
            </div>
        </div>
        <div class="card card-body agatrs-card-style-sm">
            <div class="row">
                <div class="col-md-12">
                    <NotificationBox class="text-left"></NotificationBox>
                </div>
            </div>
        </div>
    </center>
</template>

<script>
    import { mapActions, mapGetters } from "vuex";
    import NotificationBox from "@/components/App/dashboard/NotificationBox.vue";
    import { BaseCheckbox } from '@/components';
    export default {
        name: "Notifications",
        components: {
            NotificationBox,
            BaseCheckbox
        },
        data: function () {
            return {
                switches: {
                    thirtyDay: false,
                    sixtyDay: false,
                    ninetyDay: false,
                }
            };
        },
        created() {
            this.getSubscription();
        },
        computed: {
            ...mapGetters({
                subscription: "subscription/subscription",
isPartnerAccount: "authentication/isPartnerAccount"

            }),
        },
        methods: {
            ...mapActions({
                saveSubscription: "subscription/saveSubscription",
                getSubscription: "subscription/getSubscription",
            }),

            save() {
                var ctx = this;

                ctx.saveSubscription().then(() => ctx.getSubscription()).catch((error) => console.log(error)); //not handelled
            }
        },
    };
</script>

<style>
    .inline {
        display: inline-block;
        padding-right: 2rem;
        text-align: left;
    }
</style>
